const firebaseConfig = {
  apiKey: "AIzaSyA412isLfVPqxgj4X4WSSYF88b5djDoLWI",
  authDomain: "travel-guru-apps-10a2c.firebaseapp.com",
  databaseURL: "https://travel-guru-apps-10a2c.firebaseio.com",
  projectId: "travel-guru-apps-10a2c",
  storageBucket: "travel-guru-apps-10a2c.appspot.com",
  messagingSenderId: "820421769602",
  appId: "1:820421769602:web:a21d84fb74c7518578b79b"
};

export default firebaseConfig;